import React, { Component } from 'react';
import './ContractorsInvoicesTable.css';
import SimpleTable from 'components/shared/table/SimpleTable';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import { connect } from 'react-redux';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import {
  getPaginationInfo,
  searchTextSelector,
} from 'components/admin/contractors-invoices/store/selectors';
import { getCurrentUser } from 'selectors/authentication';
import {
  loadWorkOrdersRequest,
  goToWorkOrder,
} from 'actions/admin/work-orders/work-orders';
import {
  getWorkOrders,
  getCurrentPage,
} from 'selectors/admin/work-orders/work-orders';
import { WorkOrder } from 'domain/work-order';
import { WorkOrderStatusEnum } from 'services/utils/work-order-status-enum';
import Date from 'components/shared/text/Date';
import SimpleText from 'components/shared/text/SimpleText';

class ContractorsWorkOrdersWithoutInvoices extends Component {
  componentDidMount() {
    this.props.dispatch(
      loadWorkOrdersRequest({ page: 1, withoutContractorInvoice: true })
    );
  }

  componentDidUpdate() {
    simpleScrollToTop();
  }

  handlePageChange = (page) => {
    this.props.dispatch(
      loadWorkOrdersRequest({ page: page, withoutContractorInvoice: true })
    );
  };

  handleTableSelection = (index) => {
    this.props.dispatch(goToWorkOrder(this.props.workOrders.content[index].id));
  };

  render() {
    let headers = [
      'WO #',
      'JOB #',
      'NAME',
      'CLIENT NAME',
      'LOCATION',
      'STATUS',
      'START DATE',
      'END DATE',
    ];

    return (
      <div className="wo-without-invoices-container">
        {this.props.workOrders !== null && (
          <div className="wo-table-container">
            <SimpleTable
              className={`work-orders-table`}
              headers={headers}
              rows={this.mapWorkOrders(this.props.workOrders)}
              emptyMessage="No Work Order for Contractor"
              onRowSelected={this.handleTableSelection}
            />

            <div className="pagination-container">
              <SimplePagination
                currentPage={this.props.currentPage}
                pageSize={this.props.workOrders.pageSize}
                total={this.props.workOrders.total}
                onPageChange={this.handlePageChange}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  mapWorkOrders = (workOrders) => {
    return workOrders.content.map((element) => {
      const startDate = WorkOrder.getStartDate(element);
      const completionDate = WorkOrder.getCompletionDate(element);

      return [
        <div>{element.number.toString()}</div>,
        WorkOrder.getJobNumber(element, 'N/A'),
        WorkOrder.getName(element, 'N/A'),
        <span className="company-name-cell">
          {element.client.company_name}
        </span>,
        <SimpleText
          lines={[
            element.building.location.street_address_1,
            element.building.location.city,
          ]}
        />,
        WorkOrderStatusEnum.create(element.status).label,
        startDate !== null ? <Date value={startDate} format="ll" /> : 'TBD',
        completionDate !== null ? (
          <Date value={completionDate} format="ll" />
        ) : (
          'TBD'
        ),
      ];
    });
  };
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    currentPage: getCurrentPage(state),
    workOrders: getWorkOrders(state),
    paginationInfo: getPaginationInfo(state),
    searchText: searchTextSelector(state),
  };
})(ContractorsWorkOrdersWithoutInvoices);



// WEBPACK FOOTER //
// ./src/components/admin/contractors-invoices/ContractorsWorkOrdersWithoutInvoices.js